import { canAccessMenuSite, hasMenu, selectUser, useAuthStore, type MenuKey } from "@safers/auth";

/**
 * 현장 화면의 종류와 **헤더 전환기에 뜨는 것**.
 *
 * 컴포넌트 파일에서 분리했다 — 한 파일이 컴포넌트와 컴포넌트 아닌 것을 같이 내보내면
 * Fast Refresh 가 그 파일 전체를 새로 마운트해, 개발 중 상태가 매번 날아간다.
 */
export type SiteMode = "site" | "cctv" | "health" | "playback";

/** 전환기에 뜨는 셋. `playback` 은 여기 없다 — CCTV 안쪽 화면이라 따로 세우지 않는다. */
export const NAV_MODES: SiteMode[] = ["site", "health", "cctv"];

const MODE_MENU: Record<SiteMode, MenuKey> = {
  site: "CONTROL",
  health: "HEALTH",
  cctv: "CCTV",
  playback: "CCTV",
};

export function useSiteModes(siteId: string | number | null | undefined, current: SiteMode) {
  const user = useAuthStore(selectUser);
  const numericId = siteId == null ? null : Number(siteId);
  return NAV_MODES.filter(
    (mode) =>
      mode === current ||
      (numericId == null
        ? hasMenu(user, MODE_MENU[mode])
        : canAccessMenuSite(user, numericId, MODE_MENU[mode]))
  );
}
